module.exports = __webpack_public_path__ + "static/media/29.00ed6e14.jpg";